import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { EmotionIconBase } from '@emotion-icons/emotion-icon';
export var VxLive = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentcolor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(EmotionIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 64 64"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 43.78c-5.185-3.807-8.553-9.949-8.553-16.872C11.197 15.368 20.553 6 32.077 6c11.525 0 20.881 9.368 20.881 20.908 0 6.901-3.347 13.026-8.503 16.835 1.289 1.335 4.389 3.749 11.695 6.938.633.277 1.915 2.28 1.799 4.182-.092 1.492-8.047 2.345-8.047 2.345s-10.113.716-17.849.782c-7.821.068-11.885-.222-17.201-.673-5.058-.429-9.128-1.538-8.886-2.834.385-2.063.721-3.19 1.801-3.68 7.419-3.366 10.619-5.714 11.983-7.023zm12.327-27.806c-6.027 0-10.923 4.898-10.923 10.934 0 6.035 4.896 10.934 10.923 10.934 6.028 0 10.924-4.899 10.924-10.934 0-6.036-4.896-10.934-10.924-10.934zm0 5.357c3.073 0 5.566 2.5 5.566 5.577a5.573 5.573 0 0 1-5.566 5.576c-3.072 0-5.565-2.499-5.565-5.576 0-3.077 2.493-5.577 5.565-5.577z"
  }));
});
VxLive.displayName = 'VxLive';
export var VxLiveDimensions = {
  height: 64,
  width: 64
};